import { Col } from "antd";
import styled from "styled-components";
import theme from "../../../theme";

export const PhaseEBookBannerSection = styled.div`
  margin-top: 72px;
  margin-bottom: 96px !important;
  @media (max-width: 992px) {
    margin-bottom: 96px !important;
  }
  @media (max-width: 480px) {
    margin-bottom: 72px !important;
  }
`;

export const BannerDesc = styled.div`
  p {
    margin-bottom: 50px;
    font-size: 24px;
    line-height: 36px;
  }
  p strong {
    font-weight: 500;
  }

  @media (max-width: 480px) {
    p {
      font-size: 20px;
      line-height: 34px;
    }
  }
`;

export const FormCol = styled(Col)`
  padding-left: 63px;

  @media (max-width: 1024px) {
    padding-left: 0px;
  }

  @media (max-width: 768px) {
    padding-left: 0px;
    width: 100%;
  }
`;

export const FormSection = styled.div`
  border-top: 1px solid ${theme.black};
`;

export const SectionTitle = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 20px;
  margin-top: 8px;
`;
